import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "rel", "mode", "disabled", "href", "size", "loading", "onClick", "tabIndex", "component"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { EmbersLoading } from '../loading';
import { StyledLink } from './linkStyles';
import { onEnterKeyPress } from '../utils/wcagUtils';
import { useIntl } from 'react-intl';
export var useLinkAriaLabel = function useLinkAriaLabel(props) {
  var intl = useIntl();
  var label = props['aria-label'] || props.children;
  return props.target === '_blank' ? intl.formatMessage({
    id: 'embers.accessibility.opensNewPage.label',
    defaultMessage: '{link} (opens in new page)'
  }, {
    link: label
  }) : label;
};
export var EmbersLink = function EmbersLink(_ref) {
  var _classnames;
  var children = _ref.children,
    className = _ref.className,
    rel = _ref.rel,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'white' : _ref$mode,
    disabled = _ref.disabled,
    href = _ref.href,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    onClick = _ref.onClick,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'a' : _ref$component,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var target = otherProps['target'];
  var ariaLabel = useLinkAriaLabel({
    target: target,
    'aria-label': otherProps['aria-label'],
    children: children
  });
  var handleKeyDown = function handleKeyDown(e) {
    onClick && onClick(e);
    if (href) {
      target === '_blank' ? window.open(href) : window.location.assign(href);
    }
  };
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    className: classnames('EmbersLink', (_classnames = {}, _defineProperty(_classnames, "EmbersLink-".concat(size), size), _defineProperty(_classnames, 'EmbersLink-loading', loading), _defineProperty(_classnames, 'EmbersLink-disabled', disabled), _defineProperty(_classnames, 'EmbersLink-button', component === 'button'), _classnames), className),
    rel: otherProps.target === '_blank' && !rel ? 'noreferrer' : rel,
    mode: mode,
    href: disabled || loading ? undefined : href,
    tabIndex: loading || disabled ? -1 : tabIndex,
    onClick: disabled || loading ? undefined : onClick,
    onKeyDown: function onKeyDown(e) {
      return onEnterKeyPress(e, handleKeyDown);
    },
    as: component,
    "aria-label": disabled || loading ? undefined : ariaLabel
  }, otherProps), loading && /*#__PURE__*/React.createElement(EmbersLoading, {
    size: "small",
    className: "EmbersLink-loading-icon"
  }), children);
};